import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import config from "./App/config";

const env = process.env.HOST;

let sentryEnv = "";

if (env.includes("cv")) {
    if (env.includes("qa")) sentryEnv = "cv-qa";
    else if (env.includes("prod")) sentryEnv = "cv-production";
} else if (env.includes("uv")) {
    if (env.includes("staging")) sentryEnv = "uv-staging";
    else if (env.includes("prod")) sentryEnv = "uv-production";
}

Sentry.init({
    dsn: config.sentryDsn,
    integrations: [new BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: env.includes("prod") ? 0.7 : 1.0,
    environment: sentryEnv,
    enabled:
        env.includes("prod") || env.includes("qa") || env.includes("staging")
            ? true
            : false
});

ReactDOM.render(<App />, document.getElementById("app-root"));
